// extracted by mini-css-extract-plugin
module.exports = {"Timer":"Timer_Timer__beGiO","Right":"Timer_Right__2bqI_","Project":"Timer_Project__ot-Yw","TaskName":"Timer_TaskName__1yGdC","Indicators":"Timer_Indicators__1eDiY"};